import { Fragment, useEffect, useContext } from "react"
import { UserContext } from "../../../../../../context/UserContext"
import { InputAdornment, OutlinedInput, Stack, Typography } from "@mui/material"
import { FormContainer, NavButtons } from "../../../../Menu/Flow"
import styles from './styles'
import { Styles } from "../../../../../../legacyComponents/config"
import employerFlowStyles from "../../styles"

export default function AllowanceMetal(props) {
    const { getEmployerPlan, getPermissibleClass } = useContext(UserContext)
    const { mode, exitUrl, step, formik, displayOnly, permissibleClassId } = props

    let employerPlan = null
    let permissibleClass = null
    if (permissibleClassId) {
        permissibleClass = getPermissibleClass(permissibleClassId)
        const employerPlanId = permissibleClass?.employerPlanId
        employerPlan = getEmployerPlan(employerPlanId)
    }
    const planType = employerPlan?.type || ""

    const { values, errors, touched, setValues, setFieldValue, setFieldTouched, submitCount } = formik
    const shouldShowErrors = submitCount > 0

    useEffect(() => {
        if (submitCount > 0) {
            formik.resetForm({ values: formik.values })
        }
    }, [submitCount, formik.resetForm, formik.values])

    // Mark metalPercent as touched when submitCount > 0 (so errors display on next click)
    useEffect(() => {
        if (shouldShowErrors && errors?.metalPercent) {
            setFieldTouched("metalPercent", true, false)
        }
    }, [shouldShowErrors, errors?.metalPercent, setFieldTouched])

    return (
        <Stack spacing="30px" height="100%">
            <FormContainer>
                <Typography variant="h2" sx={employerFlowStyles.h2}>Metal and Percentage</Typography>

                <Stack spacing={2} sx={{ marginTop: "20px" }}>
                    <Typography>Enter metal level and percentage for calculating HRA allowance</Typography>

                    <Fragment>
                        <Stack direction="row" spacing={2}>
                            <Stack flex={1}>
                                <Typography sx={{ marginBottom: "8px" }}>
                                    Metal Level
                                </Typography>
                                <select
                                    value={values.metalLevel}
                                    onChange={(evt) => { setValues({ ...values, metalLevel: evt.target.value }) }}
                                    disabled={displayOnly}
                                    style={{
                                        width: "100%",
                                        padding: "12px",
                                        border: `1px solid ${(touched.metalLevel && errors.metalLevel) || (shouldShowErrors && !values.metalLevel) ? "#dc2626" : "#ACBEE8"}`,
                                        borderRadius: "8px",
                                        fontSize: "14px",
                                        backgroundColor: "white",
                                        cursor: "pointer"
                                    }}
                                >
                                    <option value={""}>Select Metal Level</option>
                                    <option value={"Bronze"}>Bronze</option>
                                    <option value={"Silver"}>Silver</option>
                                    <option value={"Gold"}>Gold</option>
                                </select>
                                {((touched.metalLevel && errors.metalLevel) || (shouldShowErrors && !values.metalLevel)) && (
                                    <div className="error-message-fields">{errors.metalLevel || "Metal level is required"}</div>
                                )}
                            </Stack>

                            <Stack flex={1}>
                                <Typography sx={{ marginBottom: "8px" }}>
                                    Percent of Plan to Cover
                                </Typography>
                                <OutlinedInput
                                    type="number"
                                    value={values.metalPercent ?? ''}
                                    name="metalPercent"
                                    onChange={(evt) => {
                                        const inputValue = evt.target.value
                                        const value = inputValue === '' ? undefined : (isNaN(Number(inputValue)) ? undefined : Number(inputValue))
                                        setFieldValue("metalPercent", value, true)
                                    }}
                                    onBlur={() => {
                                        setFieldTouched("metalPercent", true)
                                    }}
                                    endAdornment={<InputAdornment position="end">%</InputAdornment>}
                                    disabled={displayOnly}
                                    sx={{
                                        ...styles.outlinedInput,
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: (touched.metalPercent && errors.metalPercent) || (submitCount > 0 && (!values.metalPercent || values.metalPercent === 0)) ? "#dc2626" : "#ACBEE8"
                                        },
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: (touched.metalPercent && errors.metalPercent) || (submitCount > 0 && (!values.metalPercent || values.metalPercent === 0)) ? "#dc2626" : "#ACBEE8"
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: (touched.metalPercent && errors.metalPercent) || (submitCount > 0 && (!values.metalPercent || values.metalPercent === 0)) ? "#dc2626" : "#ACBEE8"
                                        }
                                    }}
                                />
                                {((touched.metalPercent && errors.metalPercent) || (submitCount > 0 && (!values.metalPercent || values.metalPercent === 0))) && (
                                    <div className="error-message-fields">
                                        {errors.metalPercent || (values.metalPercent === 0 ? "Percent of plan to cover must be greater than 0" : "Percent of plan to cover is required")}
                                    </div>
                                )}
                            </Stack>
                        </Stack>

                        <Typography sx={styles.link} component="div">
                            Click on our <Typography component="span" sx={{ color: Styles.Color.tertiary, display: "inline" }} onClick={() => { window.open('/calculator/metal-based-ichra-employer', '_blank') }}>Metal-Based ACA-Compliant ICHRA Cost Calculator</Typography> and see how much your employees will receive
                        </Typography>
                    </Fragment>
                </Stack>
            </FormContainer>

            <NavButtons mode={mode} enableSave={true} exitUrl={exitUrl} step={step} />
        </Stack>
    )
}
